import { render, staticRenderFns } from "./cgqModal.vue?vue&type=template&id=28a6dd8e&scoped=true"
import script from "./cgqModal.vue?vue&type=script&lang=js"
export * from "./cgqModal.vue?vue&type=script&lang=js"
import style0 from "./cgqModal.vue?vue&type=style&index=0&id=28a6dd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6dd8e",
  null
  
)

export default component.exports